import React from "react";
import PropTypes from "prop-types";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { SFNavTabs, SFNavTab } from "../tabBar";
import { hasPermission } from "../authorized";
import CreateReactPortal from "../../hooks/createReactPortal";
import getStyled from "../../hooks/getStyled";
import { getFormattedPathUrl } from "../../helpers/pathFunctions";

const { styled } = getStyled();

const Wrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2.5),
}));

const SFTabsLayout = ({ tabs, excludeTabsFromPaths = [] }) => {
  const location = useLocation();
  const { ...allParams } = useParams();

  return (
    <>
      {excludeTabsFromPaths.filter((x) =>
        location.pathname.includes(getFormattedPathUrl(x, allParams))
      ).length === 0 &&
        CreateReactPortal(
          <Wrapper>
            <SFNavTabs scrollableTabs autoWidthTabs>
              {tabs
                .filter((x) => hasPermission(x.permissions))
                .map((tab, index) => (
                  <SFNavTab
                    key={index}
                    path={getFormattedPathUrl(tab.path, allParams)}
                    label={tab.label}
                    disabled={tab.disabled}
                  ></SFNavTab>
                ))}
            </SFNavTabs>
          </Wrapper>,
          //this is the root element to append the tabs to
          //this element is placed inside appbar index file
          document.getElementById("tabsLayoutRoot")
        )}
      <Outlet></Outlet>
    </>
  );
};

SFTabsLayout.propTypes = {
  /* The tabs to display */
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      path: PropTypes.string,
      permissions: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired,
  /*
   ** The paths to exclude the tabs from
   ** This is useful when you want to render a nested route inside this layout, but you don't want the tabs to be rendered
   ** Example: benchmark screen has 3 tabs and the jobs has some nested routes that should have the tabs such as business capabilities
   ** but also some nested routes that should not have the tabs such as job details
   ** In both cases the jobs is the parent route
   */
  excludeTabsFromPaths: PropTypes.arrayOf(PropTypes.string),
};

export default SFTabsLayout;
